import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiHelper } from "../../../utils/apiHelper";
import { toast } from "react-toastify";

export const fetchCompanyDetails = createAsyncThunk(
    "company/fetchCompanyDetails",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/${startupId}/company`);
            return response.data.startupCompany;
        } catch (error) {
            toast.error('Şirket bilgileri yüklenirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

export const updateCompanyDetails = createAsyncThunk(
    "company/updateCompanyDetails",
    async (companyData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.put("/startup/startup-company", companyData);
            if (response.data.code === "00000") {
                toast.success('Şirket bilgileri başarıyla güncellendi');
                return companyData;
            }
            throw new Error("Failed to update company details");
        } catch (error) {
            toast.error('Şirket bilgileri güncellenirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

export const fetchPartners = createAsyncThunk(
    "company/fetchPartners",
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/${startupId}/partners`);
            return response.data.companyPartners;
        } catch (error) {
            toast.error('Partner bilgileri yüklenirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

export const addPartner = createAsyncThunk(
    "company/addPartner",
    async (partnerData, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.post("/startup/startup-partner", partnerData);
            if (response.data.code === "00000") {
                toast.success('Partner başarıyla eklendi');
                return partnerData;
            }
            throw new Error("Failed to add partner");
        } catch (error) {
            toast.error('Partner eklenirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

export const deletePartner = createAsyncThunk(
    "company/deletePartner",
    async (startupPartnerId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.delete("/startup/startup-partner", {
                data: { startupPartnerId }
            });
            if (response.data.code === "00000") {
                toast.success('Partner başarıyla silindi');
                return startupPartnerId;
            }
            throw new Error("Failed to delete partner");
        } catch (error) {
            toast.error('Partner silinirken bir hata oluştu');
            return rejectWithValue(error.message);
        }
    }
);

const companySlice = createSlice({
    name: "company",
    initialState: {
        details: {
            capital: "",
            city: "",
            district: "",
            address: ""
        },
        partners: [],
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCompanyDetails.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCompanyDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.details = action.payload;
            })
            .addCase(fetchCompanyDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(fetchPartners.fulfilled, (state, action) => {
                state.partners = action.payload;
            })
            .addCase(addPartner.fulfilled, (state, action) => {
                state.partners.push(action.payload);
            })
            .addCase(deletePartner.fulfilled, (state, action) => {
                state.partners = state.partners.filter(
                    partner => partner.id !== action.payload
                );
            });
    }
});

export default companySlice.reducer; 